import "./index.scss";

type LoadingDotsProps = {
    compact?: boolean;
};

const LoadingDots = ({ compact = false }: LoadingDotsProps) => {
    return (
        <span className={`loading-dots${compact ? " loading-dots--compact" : ""}`}>
            <span className="bouncing-loader">
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
            </span>
        </span>
    );
};

export default LoadingDots;
